import styled from 'styled-components'
const OrderSummariesWrapper = styled.div`
  .filter-section {
    background: ${(props) => props.theme.tokens.surfaceHover};
    border: 1px solid ${(props) => props.theme.tokens.borderSubtle};
    border-radius: 6px;
    padding: 12px;

    .filter-item {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .label {
        margin-right: 12px;
      }
    }
  }

  .focus-animation-none {
    &.ant-btn-default:focus {
      color: ${(props) => props.theme.tokens.textSecondary};
      border: 1px solid ${(props) => props.theme.tokens.borderInput};
    }
  }

  .justify-content-end { justify-content: end; }
  .justify-content-md-end { justify-content: flex-start; }
  .margin-right-8 { margin-right: 8px; }
  .margin-bottom-10 { margin-bottom: 10px; }
  .margin-bottom-12 { margin-bottom: 12px; }
  .padding-4 { padding: 4px; }

  .mobile-filter-toggle {
    margin-top: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .advanced-filters.is-hidden {
    display: none;
  }

  .pl-filter {
    margin-top: 8px;
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }

  .pl-filter-select {
    width: 150px;
    max-width: 100%;
  }

  .responsive-select,
  .date-type-select,
  .province-select,
  .state-filter-select {
    width: 100%;
  }

  .state-filter {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .state-filter-label {
    color: ${(props) => props.theme.tokens.textSecondary};
  }

  .date-row {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 8px;
  }

  .date-row-label {
    font-size: 13px;
  }

  .responsive-range-picker {
    width: 100%;
  }

  @media (min-width: 768px) {
    .justify-content-md-end { justify-content: flex-end; }

    .responsive-select { width: 220px; }
    .date-type-select { width: 150px; }
    .province-select { width: 150px; }
    .state-filter-select { width: 300px; }

    .state-filter {
      flex-direction: row;
      align-items: center;
    }

    .state-filter-label {
      margin-right: 10px;
    }

    .date-row {
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
      gap: 10px;
    }

    .responsive-range-picker {
      width: auto;
    }
  }

  .order-card-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .order-card {
    border: 1px solid ${(props) => props.theme.tokens.borderSubtle};
    border-radius: 6px;
    padding: 12px;
    background: ${(props) => props.theme.tokens.surface};
  }

  .order-card .order-card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 8px;
  }

  .order-card .order-card-number {
    font-size: 16px;
    font-weight: 600;
  }

  .order-card .order-card-state {
    font-size: 12px;
    color: ${(props) => props.theme.tokens.textSecondary};
    text-align: right;
  }

  .order-card .order-card-customer {
    font-size: 13px;
    margin-bottom: 8px;
    padding-bottom: 8px;
    border-bottom: 1px dashed ${(props) => props.theme.tokens.borderSubtle};
  }

  .order-card .order-card-customer-name {
    font-weight: 600;
    margin-bottom: 2px;
  }

  .order-card .order-card-customer-row {
    color: ${(props) => props.theme.tokens.textSecondary};
    margin-top: 2px;
    word-break: break-word;
  }

  .order-card .order-card-row {
    font-size: 13px;
    color: ${(props) => props.theme.tokens.textSecondary};
    margin-bottom: 4px;
    display: flex;
    justify-content: space-between;
    gap: 8px;
  }

  .order-card .order-card-label {
    color: ${(props) => props.theme.tokens.textMuted};
  }

  .order-card .order-card-value {
    text-align: right;
    word-break: break-word;
  }

  .order-card .order-card-detail {
    font-size: 13px;
    color: ${(props) => props.theme.tokens.textSecondary};
    margin-bottom: 8px;
    word-break: break-word;
  }

  .order-card .order-card-footer {
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid ${(props) => props.theme.tokens.borderSubtle};
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    color: ${(props) => props.theme.tokens.textSecondary};
  }

  .order-card-pagination {
    margin-top: 16px;
    text-align: center;
  }
`

export default OrderSummariesWrapper
